let environment;
if (process.env.NODE_ENV === "development") {
  environment = { apiUrl: "http://localhost:3000/api" };
} else if (window.location.host === 'moderation.dev.bearwww.com') {
  // Using same env detection logic as bearwww project but this is NOT the way
  // FIXME please refactor this to use a better method @jsdevs
  environment = { apiUrl: "https://api2.dev.bearwww.com/api" };
} else {
  environment = { apiUrl: "https://api2.bearwww.com/api" };
}

const config = {
  environment,
};

export default config;
